// @ts-ignore
import polycrc from 'polycrc'

export const calculateCRC8 = (input: string): number => {
    return polycrc.crc8(input);
}